import { useCallback, useState } from "react";

interface UseAjaxStateReturn<T> {
  data: T | undefined;
  loading: boolean;
  error: unknown;
  setData: (data: T) => void;
  startingRequest: () => void;
  requestFinished: () => void;
  setError: (error: unknown) => void;
}

const useAjaxState = <T>(initialData?: T): UseAjaxStateReturn<T> => {
  const [data, setData] = useState<T | undefined>(initialData);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<unknown | undefined>();

  const startingRequest = useCallback(() => {
    setLoading(true);
    setError(undefined);
    setData(undefined);
  }, []);
  const requestFinished = useCallback(() => setLoading(false), []);
  return {
    data,
    loading,
    error,
    setData,
    startingRequest,
    requestFinished,
    setError,
  };
};

export { useAjaxState, UseAjaxStateReturn };
